export function toSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[àáâãä]/g, 'a')
    .replace(/[èéêë]/g, 'e')
    .replace(/[ìíîï]/g, 'i')
    .replace(/[òóôõö]/g, 'o')
    .replace(/[ùúûü]/g, 'u')
    .replace(/[ċ]/g, 'c')
    .replace(/[ġ]/g, 'g')
    .replace(/[ħ]/g, 'h')
    .replace(/[ż]/g, 'z')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/[\s]+/g, '-')
    .replace(/-+/g, '-');
}
